import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Empty, LibraryIcon, Skeleton } from '@treams/treams-ui';

import LearningItemCard from './LearningItemCard';

const LearningEventsList = (props: {
	events: graphql.LearningEventConnection;
	courses?: graphql.LearningCourseFragment[];
	hasRecommendations?: boolean;
	loading?: boolean;
}) => {
	const { t } = useTranslation();
	const courses = props.courses ?? [];
	const eventEdges = props.events?.edges ?? [];
	const isEmpty =
		eventEdges.length === 0 && courses.length === 0 && !props.hasRecommendations;

	if (props.loading) {
		return (
			<Flex mb={3} ml={-3} flexWrap="wrap" alignItems="stretch" flexGrow={1}>
				<Skeleton.Repeat count={3}>
					<Box width={1 / 3} pl={3} mb={3}>
						<LearningItemCard.Skeleton />
					</Box>
				</Skeleton.Repeat>
			</Flex>
		);
	}

	if (isEmpty) {
		return (
			<Box width={1}>
				<Empty.Card icon={<LibraryIcon />} title={t('learning.events.empty')} />
			</Box>
		);
	}

	return (
		<Flex mb={3} ml={-3} flexWrap="wrap" alignItems="stretch" flexGrow={1}>
			{eventEdges.map(({ node }) => (
				<Box width={1 / 3} pl={3} mb={3} key={node.id}>
					<LearningItemCard event={node} />
				</Box>
			))}
			{courses.map((course) => (
				<Box width={1 / 3} pl={3} mb={3} key={course.id}>
					<LearningItemCard course={course} />
				</Box>
			))}
		</Flex>
	);
};

export default LearningEventsList;
